module.exports = new __parcel__URL__("neon-phrases-2.488d26b9.jpg").toString();